import Box from '@mui/material/Box';
import * as React from 'react';
import type { AuditLog, ChargePointLog } from '../../../../../../app/ApiGen';
import { Normalised } from '../../../../../../utils/request';

export type TableChargePointLog = Pick<
  Normalised<ChargePointLog>,
  'chargePointEventDate' | 'eventPayload' | 'eventType' | 'messageId' | 'serverEventDate'
>;

const getParsedData = (data: unknown) => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data) as Record<string, unknown>;
      // eslint-disable-next-line no-empty -- there's no way to conditionally parse JSON without a try catch
    } catch {}
  }

  return data;
};

export const renderLogData = (log: TableChargePointLog): JSX.Element => {
  if (!log.eventPayload) {
    return <Box component="pre" m={2} />;
  }

  const logData = log.eventPayload as Record<string, unknown>;
  const displayData = logData.data ? { ...logData, data: getParsedData(logData.data) } : logData;

  return (
    <Box component="pre" m={2}>
      {JSON.stringify(displayData, null, 2)}
    </Box>
  );
};

export const renderAuditLogData = (log: AuditLog): React.ReactNode => {
  if (!log) {
    return <Box component="pre" m={2} />;
  }

  const logData = log as unknown as Record<string, unknown>;
  const displayData = logData.data ? { ...logData, data: getParsedData(logData.data) } : logData;

  return (
    <Box component="pre" m={2}>
      {JSON.stringify(displayData, null, 2)}
    </Box>
  );
};
